import { Spinner, MenuItemProps, MenuItem } from '@fluentui/react-components';
import { LegacyRef, MouseEvent, forwardRef, useState } from 'react';

type TMenuItemLoadingProps = MenuItemProps & {
  loading?: boolean;
};

// ON CLICK IS NOT WORKING, AS A MENUITEM IS REMOUNTED AFTER CLOSING THE MENU
const MenuItemLoading = forwardRef(({ loading = false, ...props }: TMenuItemLoadingProps, ref) => {
  const [working, setWorking] = useState(false);
  if (props.onClick) {
    const oldOnClick = props.onClick;
    props.onClick = async (
      event: MouseEvent<HTMLDivElement, globalThis.MouseEvent> & MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
    ) => {
      setWorking(true);
      try {
        await oldOnClick(event);
      } finally {
        setWorking(false);
      }
    };
  }

  if (!props.disabled && (loading || working)) {
    props.icon = <Spinner size="tiny" />;
    props.disabled = true;
  }

  return <MenuItem {...props} ref={ref as LegacyRef<HTMLDivElement> | undefined} />;
});

export { MenuItemLoading };
